module.exports = "{{#if avatarUrl}} <span style=background-image:url({{avatarUrl}}) class=\"avatar-icon avatar-icon_list\"></span> {{else}} <span class=\"avatar-icon avatar-icon_list\">{{abbreviation}}</span> {{/if}} <span class=js-fullName>{{text}}</span>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/reference/templates/userReferenceListItem.hbs
// module id = 680
// module chunks = 0